import React from "react"
import types from "prop-types"
import AuditItem from "./AuditItem"
import EmptyAudits from "./EmptyAudits"

const SignInHistoryTab = ({ signInAudits }) => {
  if (signInAudits.length === 0) {
    return <EmptyAudits />
  }

  return (
    <>
      <h2 className="tab-title">Sign-in History</h2>
      <div className="admin-user-sign-in-history">
        <div className="admin-user-sign-in-history-headers">
          <span>Action</span>
          <span>Date</span>
          <span>IP Address</span>
          <span>Impersonator</span>
          <span>Organization</span>
        </div>
        {
          signInAudits.map((audit, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <AuditItem key={index} audit={audit} />
          ))
        }
      </div>
    </>
  )
}

SignInHistoryTab.propTypes = {
  signInAudits: types.arrayOf(types.object).isRequired,
}

export default SignInHistoryTab
